module.exports = __webpack_public_path__ + "static/learnmore-7d7c06b60bc00434e3303750f8a10348.mp4";